<template>
  <div class="animated fadeIn">
    <spot-prices/>

    <div class="row">
      <div class="col-xl-12">
        <table class="table table-bordered table-striped table-sm table-text-no-wrap">
          <thead>
          <tr>
            <th>Date</th>
            <th>Status</th>
            <th>Item</th>
            <th>Type</th>
            <th>Quantity</th>
            <th class="text-right">Price</th>
            <th class="text-right">Total</th>
            <th class="text-center">Bid</th>
            <th class="text-center">Ask</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in orderHistory">
            <td class="align-middle">{{item.order_created | moment('MM-DD-YYYY HH:mm')}}</td>
            <td class="align-middle">
              <div v-if="item.status">Submitted</div>
              <div v-else="item.status">Pending</div>
            </td>
            <td class="align-middle">{{item.purchase_desc}}</td>
            <td class="align-middle">{{item.order_type}}</td>
            <td class="align-middle">{{item.quantity}}</td>
            <td class="align-middle text-right">{{item.rate | currency}}</td>
            <td class="align-middle text-right">{{item.total | currency}}</td>
            <td class="align-middle text-center">
              <button v-if="item.dnb" type="button" class="btn btn-primary" style="width: 140px;">
                Please Call
              </button>
              <button v-else="item.dnb" v-on:click="sellItem(index)" type="button" class="btn btn-primary" style="width: 140px;">
                {{item.price_bid | currency}}
                &nbsp;&nbsp;<i class="fa fa-plus-circle"></i>
              </button>
            </td>
            <td class="align-middle text-center">
              <button v-if="item.dns" type="button" class="btn btn-success" style="width: 140px;">
                Please Call
              </button>
              <button v-else="item.dns" v-on:click="buyItem(index)" type="button" class="btn btn-success" style="width: 140px;">
                {{item.price_ask | currency}}
                &nbsp;&nbsp;<i class="fa fa-plus-circle"></i>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <announcement></announcement>
  </div>
</template>

<script>
  import { pricing } from '../../components/mixins/pricing'
  import { Announcement } from '../../components/'

  export default {
    name: 'inventory',
    mixins: [pricing],
    components: {
      Announcement
    },
    data () {
      return {
        context: 'order context',
        orderHistory: [],
        currentSpot: null
      }
    },
    watch: {
      orderHistory: function (newVal, oldVal) {
        this.priceItems()
      },
      spot_prices: function (newVal, oldVal) {
        this.priceItems()
      }
    },
    methods: {
      buyItem (index) {
        document.body.classList.remove('aside-menu-hidden')
        this.$bus.$emit('buy-item', this.orderHistory[index])
      },
      sellItem (index) {
        document.body.classList.remove('aside-menu-hidden')
        this.$bus.$emit('sell-item', this.orderHistory[index])
      },
      getOrderHistory () {
        this.$http.get('order/history').then(response => {
          this.orderHistory = response.body
        }, response => {
          console.log(response)
        })
      },
      priceItems () {
        for (var i = 0, len = this.orderHistory.length; i < len; i++) {
          const currentPrice = this.priceItem(this.currentSpot, this.orderHistory[i])
          this.orderHistory[i].price_bid = currentPrice.bid
          this.orderHistory[i].price_ask = currentPrice.ask
        }
      }
    },
    created () {
      this.$bus.$on('spot-price', ($event) => {
        if ($event['GOLD'] && $event['SILV'] && $event['PLAT'] && $event['PALL']) {
          this.currentSpot = $event
          if (this.orderHistory.length === 0) {
            this.getOrderHistory()
          }
        }
      })
      this.$bus.$on('order-executed', ($event) => {
        this.getOrderHistory()
      })
    },
    beforeMount () {
      this.$bus.$emit('request-spot-price')
    }
  }
</script>

<style>
  .table-text-no-wrap td {
    max-width: 280px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// OrderHistory.vue?ed75ecb6